import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function getZone(payload: any = {}) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({
      search: payload?.search || "",
      page: String(payload?.page || 1),
      limit: String(payload?.limit || 25),
      city: payload?.city || "",
      cityId: payload?.cityId || "",
      countryId: payload?.countryId || "",
      stateId: payload?.stateId || "",
    });
    if (payload?.isTop != null && payload?.isTop !== "") {
      qs.set("isTop", String(payload.isTop));
    }
    const response = await makeCall(`${urls.GETZONE}?${qs.toString()}`, callParams);
    return response;
  } catch (error: any) {
    if (error?.status === 404) {
      return { success: 0, data: [] };
    }
    throw error;
  }
}

export async function getZoneById(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETZONE}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addZone(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDZONE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteZone(id: any) {
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(`${urls.DELETEZONE}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
